export default __webpack_public_path__ + "static/media/ALXSE_Certificate-Koech.34b4167f.png";